// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page_wrapper__fEsAY","styledSidebar":"page_styledSidebar__SsuAb","useCaseContainer":"page_useCaseContainer__0mJjO","main":"page_main__RTMdd"};